const NotFound = () =>{
    return (
        <div className='notFound'>
            <h1>Page NotFound</h1>
        </div>
    )
}

export default NotFound